/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageContent } from '../../models/image-content';
import { ImageContentApiRespModel } from '../../models/image-content-api-resp-model';

export interface ApiMasterImageContentAddPost$Params {
      body?: ImageContent
}

export function apiMasterImageContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterImageContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterImageContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageContentApiRespModel>;
    })
  );
}

apiMasterImageContentAddPost.PATH = '/api/Master/ImageContent/Add';
